module.exports = __webpack_public_path__ + "img/logo.88bd54b8.jpg";